<template>
	<div class="userbg">
		<infoview :tabs="4"></infoview>
		<div class="userinfobg">

			<div class="userinfotop">
				<p>{{$t('Points.Points_1')}}</p>
				<span>{{$t('Points.Points_2')}}</span>
			</div>
			<div class="pointtop row f-b">
				<!-- <el-image style="width: 100px; height: 100px" :src="url" fit="contain"></el-image> -->
				<div class="pointtopitem row f-b">
					<div class="pointtoplist">
						<span>{{$t('Points.Points_3')}}</span>
						<div class="pointtopbox">{{AVAPTformatter(KKDT0) }}<span>P</span></div>
					</div>
					<el-button type="info" @click="dialogTableVisible = true">{{$t('Points.Points_4')}}</el-button>
				</div>
			</div>
			<div class="pointtab">
				<el-table :data="tableData" style="width: 100%" header-cell-class-name="headcc">
					<el-table-column prop="PAAMSTDT" :label="$t('Points.Points_5')" align="center">
					</el-table-column>
					<el-table-column prop="name" :label="$t('Points.Points_6')" align="center">
					</el-table-column>
					<el-table-column prop="PAAADDPT" :label="$t('Points.Points_7')" :formatter="ADDPTformatter"
						align="center">
					</el-table-column>
				</el-table>
			</div>


			<div>
				<el-dialog :title="$t('Points.Points_4')" :visible.sync="dialogTableVisible">
					<el-divider></el-divider>
					<div class="pointspop">
						<p>親譲りの無鉄砲で小供の時から損ばかりしている。小学校に居る時分学校の二階から飛び降りて一週間ほど腰を抜かした事がある。なぜそんな無闇をしたと聞く人があるかも知れぬ。別段深い理由でもない。新築の二階から首を出していたら、同級生の一人が冗談に、いくら威張っても、そこから飛び降りる事は出来まい。弱虫やーい。と囃したからである。小使に負ぶさって帰って来た時、おやじが大きな眼をして二階ぐらいから飛び降りて腰を抜かす奴があるかと云ったから、この次は抜かさずに飛んで見せますと答えた。（青空文庫より）親譲りの無鉄砲で小供の時から損ばかりしている。小学校に居る時分学校の二階から飛び降りて一週間ほど腰を抜かした事がある。なぜそんな無闇をしたと聞く人があるかも知れぬ。別段深い理由でもない。新築の二階から首を出していたら、同級生の一人が冗談に、いくら威張っても、そこから飛び降りる事は出来まい。弱虫やーい。と囃したからである。小使に負ぶさって帰って来た時、おやじが大きな眼をして二階ぐらいから飛び降りて腰を抜かす奴があるかと云ったから、この次は抜かさずに飛んで見せますと答えた。（青空文庫より）
						</p>
						<p>親譲りの無鉄砲で小供の時から損ばかりしている。小学校に居る時分学校の二階から飛び降りて一週間ほど腰を抜かした事がある。なぜそんな無闇をしたと聞く人があるかも知れぬ。別段深い理由でもない。新築の二階から首を出していたら、同級生の一人が冗談に、いくら威張っても、そこから飛び降りる事は出来まい。弱虫やーい。と囃したからである。小使に負ぶさって帰って来た時、おやじが大きな眼をして二階ぐらいから飛び降りて腰を抜かす奴があるかと云ったから、この次は抜かさずに飛んで見せますと答えた。（青空文庫より）
						</p>
						<p>親譲りの無鉄砲で小供の時から損ばかりしている。小学校に居る時分学校の二階から飛び降りて一週間ほど腰を抜かした事がある。なぜそんな無闇をしたと聞く人があるかも知れぬ。別段深い理由でもない。新築の二階から首を出していたら、同級生の一人が冗談に、いくら威張っても、そこから飛び降りる事は出来まい。弱虫やーい。と囃したからである。小使に負ぶさって帰って来た時、おやじが大きな眼をして二階ぐらいから飛び降りて腰を抜かす奴があるかと云ったから、この次は抜かさずに飛んで見せますと答えた。
						</p>
					</div>
				</el-dialog>
			</div>
		</div>

	</div>
</template>

<script>
	import infoview from '../components/home/info/infoview.vue'

	export default {
		name: 'OrderInfo',
		components: {
			infoview
		},
		data() {
			return {
				tableData: [],
				dialogTableVisible: false,
				url: 'http://up.deskcity.org/pic_source/0d/73/37/0d73375c66326efdadb91535f5f1836a.jpg',
				KKDT0: 0,
			};
		},
		watch: {},
		computed: {},
		methods: {
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex === 1) {
					return 'warning-row';
				}
			},
			ADDPTformatter(row, column) {

				return Number(row.PAAADDPT).toLocaleString();
			},
			AVAPTformatter(val) {
				return Number(val).toLocaleString();
			},
			getpoint() {

				this.$api.post(this.$config.Get_Point, {
						'sMSTID': sessionStorage.getItem('log_mstid'),
					},
					// 请求成功
					success => {
						console.log(success)


						if (success.KKDT0 != '') {
							this.KKDT0 = success.KKDT0[0].PABAVAPT;
						} else {
							this.KKDT0 = 0;

						}
						if (success.KKDT1 != '') {
							this.tableData = success.KKDT1
						}
						this.tableData.map((item, index) => {
							item.name = 'レンタル'
						})
						console.log(this.tableData)
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},

		},
		created() {

		},
		mounted() {
			this.getpoint()
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:800px) {
		.userbg {
			width: 80%;
			margin: 0 auto;
			padding: 60px 0;
			display: flex;
			flex-direction: row;
		}

		.userinfotop {

			margin-bottom: 45px;
		}

		.userinfotop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
		}

		.pointtop {
			width: 70%;
		}

		.pointtab {
			border: 1px solid #ddd;
			width: 70%;
		}

		/deep/ .el-dialog {
			height: 60%;
			width: 30%;
		}

		.pointtopbox {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			color: #FE9C2C;
		}

		.pointtopbox>span {
			font-size: 30px;
			margin-left: 5px;
		}
	}

	@media only screen and (max-width:800px) {
		.userbg {
			width: 90%;
			margin: 0 auto;
			padding: 30px 0;
			display: block;
			padding-top: 10px
		}

		.userinfotop {

			margin-bottom: 25px;
		}

		.userinfotop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 20px;
		}

		.pointtop {
			width: 100%;
		}

		.pointtab {
			border: 1px solid #ddd;
			width: 100%;
		}

		/deep/ table {
			font-size: 13px;
		}

		/deep/ .el-dialog {
			height: 60%;
			width: 74%;
		}

		.pointtopbox {
			font-size: 42px;
			font-family: Roboto-Bold, Roboto;
			color: #FE9C2C;
		}

		.pointtopbox>span {
			font-size: 24px;
			margin-left: 5px;
		}
	}

	.userinfobg {
		width: 100%;
	}



	.row {
		display: flex;
		flex-direction: row;
	}

	.f-b {
		justify-content: space-between;
	}


	.pointtopitem {
		width: 100%;
	}

	.pointtoplist>span {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		margin-top: 14px;
	}


	.pointtopitem .el-button--info {
		border-radius: 3px;
		background-color: #666666;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		height: 38px;
		margin-top: 26px;
	}

	/deep/ .el-table th.el-table__cell {

		background: #ddd;
	}


	/deep/ .el-table_1_column_3 {
		text-align: center;
	}

	/deep/ .el-table_1_column_1 {
		text-align: center;
	}

	/deep/ .el-table_1_column_2 {
		text-align: center;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #666;
		font-size: 20px;
		font-weight: bold;
	}

	/deep/ .el-dialog__title {

		font-size: 20px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		line-height: 40px;
	}


	.pointspop {
		height: 100%;
		overflow: hidden;
		overflow-y: auto;
		font-size: 12px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
	}

	/deep/ .el-dialog__body {
		height: calc(100% - 70px);
		padding-top: 6px;
	}

	.orderkb {
		font-size: 32px;
		text-align: center;
	}

	/deep/ .el-divider--horizontal {
		margin: 0;
		margin-bottom: 20px;
	}
</style>
